export class AppConfigState {
    constructor() {
        this.applicationName = "";
        this.applicationUrl = "";
        this.applicationVersion = "";
        this.hasProductionVersion = false;
        this.companyName = "";
        this.companyPhone = "";
        this.companyEmail = "";
        this.companyWebsite = "";
        this.companyAddress1 = "";
        this.companyAddress2 = "";
        this.companyAddress3 = "";
        this.companyAddress4 = "";
        this.postCode = "";
        this.recaptchaSiteKey = "";
        this.authenticationMethod = "";
        this.tutorialUrl = "";
        this.applicationReleaseDesignation = "";
        this.ssoEnabled = false;
        this.environmentName = "Production";
    }
    get appTitle() {
        return this.applicationName;
    }
    ;
    static fromJson(serializedState) {
        let jsonModel = JSON.parse(serializedState);
        let viewModel = new AppConfigState();
        if (!jsonModel)
            return viewModel;
        viewModel.applicationUrl = jsonModel.applicationUrl;
        viewModel.applicationVersion = jsonModel.applicationVersion;
        viewModel.hasProductionVersion = jsonModel.hasProductionVersion;
        viewModel.companyName = jsonModel.companyName;
        viewModel.companyPhone = jsonModel.companyPhone;
        viewModel.companyEmail = jsonModel.companyEmail;
        viewModel.companyWebsite = jsonModel.companyWebsite;
        viewModel.companyAddress1 = jsonModel.companyAddress1;
        viewModel.companyAddress2 = jsonModel.companyAddress2;
        viewModel.companyAddress3 = jsonModel.companyAddress3;
        viewModel.companyAddress4 = jsonModel.companyAddress4;
        viewModel.postCode = jsonModel.postCode;
        viewModel.recaptchaSiteKey = jsonModel.recaptchaSiteKey;
        viewModel.authenticationMethod = jsonModel.authenticationMethod;
        viewModel.tutorialUrl = jsonModel.tutorialUrl;
        viewModel.applicationReleaseDesignation = jsonModel.applicationReleaseDesignation;
        viewModel.ssoEnabled = jsonModel.ssoEnabled || false;
        viewModel.environmentName = jsonModel.environmentName || "Production";
        return viewModel;
    }
    ;
}
AppConfigState.configKey = "PowerShield.BatteryPortal.AppConfig";
